module.exports = __webpack_public_path__ + "img/slide-general-test.f00ed03f.png";